import { getStrapiMedia } from '@/lib/media';
import Image from 'next/image';
import React from 'react';

const AuthorIconBox = ({ details }: any) => {
  return (
    <section className='mr-auto flex items-center rounded-[8px] dark:border-[#2f4c5e] dark:bg-[#263843] dark:max-lg:p-[6px_10px] lg:static lg:border lg:border-[#d4e3f1]  lg:bg-[#eef7ff] lg:p-[6px_10px]'>
      <Image
        className='mr-1.5  h-[25px] w-[25px] rounded-full'
        width={25}
        height={25}
        src={getStrapiMedia(details?.data?.attributes?.profile_pic)}
        alt={details?.data?.attributes?.name}
      />
      <p className='mr-4 text-sm font-semibold text-[#1c2534] dark:text-white'>
        {details?.data?.attributes?.name}
      </p>
    </section>
  );
};

export default AuthorIconBox;
